export default __webpack_public_path__ + "static/media/Glitch1.ac6cd481.mp3";